const FaqData = [
    {
        "id" : "1",
        "Question" : "What benefits will I receive from being in each tier?",
        "Answer" : "Each INO will be unique and offer different kinds of valuable in-game Arata. All the Arata offered on Arata the launchpad are rare compared to what will be available in other marketplaces. We will release a blog post for each launch to detail the Arata that are available for each launch.",
    },
    {
        "id" : "2",
        "Question" : "How do I participate in INO launches?",
        "Answer" : "Each INO will be unique and offer different kinds of valuable in-game Arata. All the Arata offered on Arata the launchpad are rare compared to what will be available in other marketplaces. We will release a blog post for each launch to detail the Arata that are available for each launch.",
    },
    {
        "id" : "3",
        "Question" : "Which launch models does Arata Launch use?",
        "Answer" : "",
    },
    {
        "id" : "4",
        "Question" : "What is the 7 day withdrawal period?",
        "Answer" : "",
    },
    {
        "id" : "5",
        "Question" : "If my staked amount grows due to rewards from staking will my tier be automatically updated?",
        "Answer" : "",
    },
    {
        "id" : "6",
        "Question" : "Does Arata Launch launch project tokens?",
        "Answer" : "",
    },
]
export default FaqData;